<template>
  <div class="alert alert-danger">
    {{ $t("HALL_IS_MARKED_FOR_RELOADING_BECAUSE_OF_THE_FOLLOWING_REASONS") }}:
    <template v-if="lastControl && !lastControl.package">
      <br />
      {{ $t("EXTERNAL_VIEW_COLOR_AND_OVERALL_PACKAGING") }}
    </template>
    <template v-if="lastControl && !lastControl.instructions">
      <br />
      {{ $t("PRODUCT_COMPLIANCE_WITH_THE_INSTRUCTIONS_FOR_REPACKAGING") }}
    </template>
    <template v-if="lastControl && !lastControl.batch">
      <br />
      {{ $t("CLARITY_AND_VERACITY_OF_THE_BATCH_NUMBER_AND_EXPIRATION_DATE") }}
    </template>
    <template v-if="lastControl && lastControl.notes">
      <br />
      {{ lastControl.notes }}
    </template>
  </div>
</template>

<script>
import { sortBy, last } from "lodash";

export default {
  props: {
    routemap: {
      required: true,
      type: Object
    }
  },

  computed: {
    lastControl() {
      const controls = sortBy(this.routemap.controls, "id");

      return last(controls);
    }
  }
};
</script>
